import { FormSelect, MultiSelect, PhoneInput, TextAreaField, TextField } from "@components/input"
import { Checkbox } from "@components/input/Checkbox"
import { SelectInput } from "@components/input/SelectInput"
import { FlexBox } from "@components/wrapper"
import { yupResolver } from "@hookform/resolvers/yup"
import { Contact } from "@interfaces/contact-us"
import { SelectOption } from "@interfaces/misc"
import { ProgramInfo } from "@interfaces/program"
import { SuccessModal } from "@modules/case-study/components/SuccessModal"
import { EMPLOYEE_OPTIONS } from "@modules/homepage/const/dropdownList"
import ContactServices from "@services/contact-us.services"
import ProgramsServices from "@services/program.services"
import clsx from "clsx"
import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { validationSchema } from "./validation-schema"

const DEFAULT_VALUE = {
  userFullName: "",
  companyName: "",
  userEmail: "",
  userPhoneNumber: "",
  services: [],
  programType: "",
  numberOfEmployeer: "",
  description: "",
}

function FormColumn() {
  const [agree, setAgree] = useState(false)
  const [programList, setProgramList] = useState<ProgramInfo[]>([])
  const [programOptions, setProgramOptions] = useState<SelectOption[]>([])
  const [serviceOptions, setServiceOptions] = useState<SelectOption[]>([])
  const [success, setSuccess] = useState(false)

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    clearErrors
  } = useForm<Contact>({
    resolver: yupResolver(validationSchema),
    defaultValues: DEFAULT_VALUE,
  })

  const contactServices = new ContactServices()
  const programServices = new ProgramsServices()

  useEffect(() => {
    const getDataProgram = async () => {
      try {
        const res = await programServices.getPrograms()

        if (res.isSuccess) {
          const result = res.getValue()
          setProgramList(result)
          const option: SelectOption[] = []
          result.map((value) => {
            option.push({
              label: value.programName,
              value: value.id,
            })
          })
          setProgramOptions(option)
        }
      } catch (e) {
        console.log(e)
      }
    }

    getDataProgram()
  }, [])

  function handleChangeProgram(opt: SelectOption | null) {
    if (!opt) {
      return
    }

    const findServices = programList.find((p) => p.id == opt.value)

    if (findServices) {
      const services = findServices.services
      const options = services.map((value) => {
        return {
          label: value.serviceName,
          value: value.id,
        }
      })
      setServiceOptions(options)
    }

    setValue("programType", opt.value)
    setValue("services", [])
    clearErrors('programType')
  }

  const onSubmit = async (data: Contact) => {
    try {
      const res = await contactServices.submitContactUs(data)
      if (res.isSuccess) {
        setSuccess(true)
      }
    } catch (e) {
      console.log(e)
    }
  }

  const redirect = () => {
    if (typeof window !== "undefined") {
      window.location.href = "/corporate-training"
    }
  }

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col bg-white rounded p-4 md:px-12 md:py-8 gap-4"
      >
        <FlexBox className="sm-only:flex-col gap-4">
          <TextField
            name="userFullName"
            control={control}
            placeHolder="Masukkan nama"
            label="Nama PIC"
          />
          <TextField
            name="companyName"
            control={control}
            placeHolder="Masukkan nama perusahaan"
            label="Nama Perusahaan"
          />
        </FlexBox>

        <FlexBox className="sm-only:flex-col gap-4">
          <TextField
            name="userEmail"
            control={control}
            placeHolder="Masukkan alamat email"
            label="Email PIC"
            type="email"
          />
          <PhoneInput
            name="userPhoneNumber"
            control={control}
            placeHolder="Masukkan nomor telepon"
            label="No. HP PIC"
          />
        </FlexBox>

        <SelectInput
          label="Program"
          placeholder="Pilih Program"
          options={programOptions}
          onChange={handleChangeProgram}
          errorMessage={errors.programType && errors.programType.message}
        />

        {/*// @ts-ignore*/}
        <MultiSelect
          control={control}
          name="services"
          label="Bidang"
          placeholder="Pilih Bidang"
          options={serviceOptions}
        />

        <FormSelect
          control={control}
          name="numberOfEmployeer"
          label="Jumlah Karyawan"
          placeholder="Pilih Jumlah Karyawan"
          options={EMPLOYEE_OPTIONS}
        />

        <TextAreaField
          name="description"
          control={control}
          placeHolder="Jelaskan Pelatihan yang Anda Butuhkan"
          label="Detail Kebutuhan"
        />

        <Checkbox
          checked={agree}
          onChange={() => setAgree(!agree)}
          label="Dengan menceklis, Anda bersedia untuk dihubungi oleh tim harisenin.com"
          className="flex gap-2 text-[#757575] cursor-pointer sm-only:text-xs"
        />
        <button
          className={clsx(
            `text-white p-3 rounded font-bold sm-only:text-xs`,
            agree ? "bg-blue" : "bg-gray-a8 cursor-default"
          )}
          disabled={!agree}
          type="submit"
        >
          KIRIM
        </button>
      </form>
      <SuccessModal show={success} onClose={() => redirect()} />
    </>
  )
}

export default FormColumn
